<template>
  <ion-page>
<!--     <ion-header>
      <ion-toolbar>
        <ion-img :src="logo" />
        <ion-buttons slot="end">
          <ion-button v-if="is_logged_in" @click="logout">
            <ion-icon slot="icon-only" :icon="logOutOutline"></ion-icon>
          </ion-button>    
          <ion-back-button
            :default-href="pageDefaultBackLink"
          ></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header> -->
    <ion-content class="ion-padding">
      <slot />
    </ion-content>
    <!-- <ion-footer>
        <ion-toolbar>
          <div
            class="
              full-width
              flex
              align-items-center
              ion-padding-horizontal
              justify-content-space-between
            "
          >
            <ion-button v-if="showUserSettings" slot="start">
                <ion-icon slot="icon-only" :icon="person"></ion-icon>
            </ion-button>
            <ion-button v-if="showSettings" slot="end" @click="goToSettings">
                <ion-icon slot="icon-only" :icon="settings"></ion-icon>
            </ion-button>

          </div>  
        </ion-toolbar>    
    </ion-footer> -->    
  </ion-page>
</template>

<script>
import {
  IonPage,
  //IonHeader,
  // IonFooter,
  //IonToolbar,
  IonContent,
  //IonBackButton,
  //IonButtons,
  //IonImg,
  // IonIcon
} from "@ionic/vue";

import { person, settings, logOutOutline } from "ionicons/icons";

export default {
  
    components: {
        IonPage,
        //IonHeader,
        // IonFooter,
        //IonToolbar,
        IonContent,
        //IonBackButton,
        //IonButtons,
        //IonImg,
        // IonIcon
    },
    
    props: ["pageDefaultBackLink", "showUserSettings", "showSettings"],
    
    data(){
            return {
                logo:'',
                person,
                settings,
                logOutOutline
            }
    },
    
    mounted() {
        if(process.env.VUE_APP_CUSTOMER=='jh_chicago'){
        this.logo = require('@/theme/jh_chicago.png');
        } else if(process.env.VUE_APP_CUSTOMER=='jh_newyork'){
        this.logo = require('@/theme/jh_newyork.png');
        } else if(process.env.VUE_APP_CUSTOMER=='sloan'){
        this.logo = require('@/theme/sloan.png');
        } else if(process.env.VUE_APP_CUSTOMER=='leon_demo'){
        this.logo = require('@/theme/leon_demo.png');
        }
    },

    computed: {
      is_logged_in() {
        return this.$store.getters.isAuthenticated;
      }
    },

    methods: {
        goToSettings(){
          this.$router.replace('/settings');       
        },
        logout(){
          this.$store.dispatch('logout');
          this.$router.replace('/login');
        }
    }

};
</script>

<style scoped>

    /* #container {
        text-align: center;
        left: 0;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    } */

    #container {
      padding-top:100px;
    }

    ion-img {
        width:300px;
        height:100px;
    }


</style>